import axios from "axios";
import { history } from "store";
import settings from "utils/settings";
import { requestNewToken } from "api/authApi";
import localStorageService from "utils/LocalStorageService";

const { apiUrl } = settings;

// Add a request
axios.interceptors.request.use(
    config => {
        const token = localStorageService.getAccessToken();
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        // config.headers['Content-Type'] = 'application/json';
        return config;
    },
    error => {
        Promise.reject(error);
    }
);

// Add a response interceptor
axios.interceptors.response.use(
    (response) => response,
    (error) => {
    const originalRequest = error.config;

    // console.error("localStorageService", localStorageService);
    if (error && error.response && error.response.status) {
        // console.error("originalRequest", originalRequest);
        // console.error("error", error);
        // console.error("error.response", error.response);
        // console.error("error.response.data", error.response.data);
        // console.error("error.response.data.errors", error.response.data.errors);
        // console.error("error.message", error.message);
        if (error.response.status === 401 && originalRequest.url === `${apiUrl}user/refresh`) {
            history.push("/login");
            return Promise.reject(error);
        }

        if (
            error.response.status === 401 &&
            !originalRequest._retry &&
            error.response.headers &&
            error.response.headers["token-expired"] &&
            Boolean(error.response.headers["token-expired"])
        ) {
            originalRequest._retry = true;
            const refreshToken = localStorageService.getRefreshToken();
            const jwtToken = localStorageService.getAccessToken();
            return requestNewToken(jwtToken, refreshToken)
                .then((res) => {
                    // console.error("getNewToken", res);
                    if (res.status === 200 && res.data) {
                        localStorageService.setToken(res.data);
                        axios.defaults.headers.common.Authorization = `Bearer ${localStorageService.getAccessToken()}`;
                        return axios(originalRequest);
                    }
                })
                .catch(err => {
                    console.error("error", err);
                });
        }
    }

    return Promise.reject(error);
}
);
